/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/no-unknown-property */
/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import Style from './Renegociacao25EmpConfira.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import RedButton from '@/components/atoms/RedButton';

function Renegociacao25EmpConfira() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);
  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="renegociacao25-emp-confira">
        <ContainerHome24>
          <div>
            <h2 className="confira-titulo">
              Confira como a renegociação de seu empréstimo no Quite.já é fácil
            </h2>
            <div className="confira-passos">
              <div className="confira-passo">
                <p className="confira-passo-number">1. </p>
                <p className="confira-passo-texto">Clique no botão abaixo e acesse a sua conta;</p>
              </div>
              <div className="confira-passo">
                <p className="confira-passo-number">2. </p>
                <p className="confira-passo-texto">Informe o seu CPF ou CNPJ;</p>
              </div>
              <div className="confira-passo">
                <p className="confira-passo-number">3. </p>
                <p className="confira-passo-texto">Valide seus dados;</p>
              </div>
              <div className="confira-passo">
                <p className="confira-passo-number">4. </p>
                <p className="confira-passo-texto">
                  Escolha ou simule uma oferta que cabe no seu bolso.
                </p>
              </div>
            </div>
            <RedButton
              href="https://emprestimosim.com.br/app/#/login/signInWithPassword"
              target="_blank"
              className="confira-btn"
            >
              Renegociar
            </RedButton>
          </div>
          {typeof window === 'undefined' ? (
            <></>
          ) : (
            <>
              {width > 992 && (
                <picture>
                  {/* <source type="image/webp" srcSet="assets/renegociacao25-emp/iPhone-desk.webp" /> */}
                  <source type="image/png" srcSet="assets/renegociacao25-emp/iPhone-desk.png" />
                  <img
                    src="assets/renegociacao25-emp/iPhone-desk.png"
                    alt="Mão com um celular a página de renegociação de Empréstimo com Garantia de Veículo"
                    className="confira-iphone-desk"
                  />
                </picture>
              )}
            </>
          )}
        </ContainerHome24>

        {typeof window === 'undefined' ? (
          <></>
        ) : (
          <>
            {width <= 992 && (
              <picture>
                {/* <source type="image/webp" srcSet="assets/renegociacao25-emp/iPhone.webp" /> */}
                <source type="image/png" srcSet="assets/renegociacao25-emp/iPhone.png" />
                <img
                  src="assets/renegociacao25-emp/iPhone.png"
                  alt="Mão com um celular a página de renegociação de Empréstimo com Garantia de Veículo"
                  className="confira-iphone"
                />
              </picture>
            )}
          </>
        )}
      </section>
      <style jsx>{Style}</style>
    </>
  );
}

export default Renegociacao25EmpConfira;
